import * as React from 'react';
import { useState } from 'react';
// import { range } from 'rxjs';
// import { map, filter } from 'rxjs/operators';
import styled from 'styled-components';
import PhotoList from 'react-photo-gallery';
import Slick from 'react-slick';


const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  padding: 0 0 45px;
  min-height: 100vh;
  z-index: 10;
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 105px 25px 35px;
  width: 160px;
  min-height: 176px;
  font-size: 18px;
  font-weight: bold;
  background: url(${require('../../assets/location/title_bg@2x.png')}) 0 0 no-repeat;
  background-size: 160px;
  text-align: center;
`;

const Section = styled.div`
  display: block;
  margin-top: 40px;
  width: 100%;
`;

const Modal = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0; left: 0;
  padding: 20px;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, .5);
  z-index: 10000;
  & img {
    width: 100%;

    @media (min-width: 500px) and (orientation: landscape) {
      margin: 0 auto;
      width: auto;
      height: 100vh;
    }
  }

  & .slick-slider {
    width: 100%;

    & .slick-prev {
      left: -20px;
    }

    & .slick-next {
      right: -20px;
    }

    & .slick-dots li button:before {
      color: #fff;
      opacity: 1;
    }

    & .slick-dots li.slick-active button:before {
      content:"";
      width: 20px; height: 20px;
      color: #000;
      background: url(${require('../../assets/gallery/favicon.ico')}) 0 0 no-repeat;
      background-size: 100%;
      opacity: 1;
    }
  }

  & .slick-track {
    display: flex;
    align-items: center;
  }
`;

const ModalClose = styled.button`
  position: absolute;
  top: 10px; right: 10px;
  width: 20px; height: 20px;

  &::before {
    content: "\\2716";
    color: rgba(255,255,255, 1);
  }
`;

interface IProps {
  messages?: any;
}

const Gallery = ({messages} : IProps) => {
  // range(1, 3).pipe(
  //   filter(x => x % 2 === 1),
  //   map(x => {
  //     console.log('x', x);
  //     return x+x
  //   })
  // ).subscribe(x => console.log(x));

  const photoState = {
    currentImage: 0,
    lightboxIsOpen: false
  }


  const [count, setPhoto] = useState(photoState);

  const openLightbox = (event:any, obj: any) => {
    setPhoto({
      currentImage: obj.index,
      lightboxIsOpen: true,
    })

    document.body.setAttribute('style', 'box-sizing: border-box; position: fixed; height: 100vh; padding-right: 0px; overflow: hidden;');

  }

  const closeLightbox = () => {
    setPhoto({
      currentImage: 0,
      lightboxIsOpen: false,
    })

    document.body.setAttribute('style', '');
  }

  const photos = [
    { src: `${require('../../assets/gallery/wedding01.jpg')}`, sizes: ["(min-width: 300px) 50vw"], width: 4, height: 3 },
    { src: `${require('../../assets/gallery/wedding02.jpg')}`, sizes: ["(min-width: 300px) 50vw"], width: 1, height: 1 },
    { src: `${require('../../assets/gallery/wedding03.jpg')}`, sizes: ["(min-width: 300px) 100vw"], width: 1, height: 1 },
    { src: `${require('../../assets/gallery/wedding04.jpg')}`, sizes: ["(min-width: 300px) 50vw"], width: 1, height: 1 },
    { src: `${require('../../assets/gallery/wedding05.jpg')}`, sizes: ["(min-width: 300px) 50vw"], width: 1, height: 1 },
    { src: `${require('../../assets/gallery/wedding06.jpg')}`, sizes: ["(min-width: 300px) 50vw"], width: 4, height: 3 },
    { src: `${require('../../assets/gallery/wedding07.jpg')}`, sizes: ["(min-width: 300px) 50vw"], width: 4, height: 3 },
    { src: `${require('../../assets/gallery/wedding08.jpg')}`, sizes: ["(min-width: 300px) 50vw"], width: 1, height: 1 },
  ];

  const columns = (containerWidth: number) => {
    let tempColumns = 1;
    if (containerWidth >= 300) { tempColumns = 2; }
    if (containerWidth >= 900) { tempColumns = 3; }
    if (containerWidth >= 1500) { tempColumns = 4; }
    return tempColumns;
  }

  const settings = {
    dots: true,
    infinite: true,
    initialSlide: count.currentImage,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <Wrap>
      <Title>Wedding Gallery</Title>
      <Section>
        <PhotoList photos={photos} columns={columns} onClick={openLightbox} />
        {
          count.lightboxIsOpen && (
            <Modal>
              <Slick {...settings}>
                { 
                  photos.map(item => (
                    <div key={item.src}>
                      <img src={item.src} alt={item.src} />
                    </div>
                  ))
                }
              </Slick>
              <ModalClose type="button" onClick={closeLightbox} />
            </Modal>
          )
        }
      </Section>
    </Wrap>
  );
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/gallery/index.tsx